import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type AccessoryPackClasses = 'container' | 'label';

const accessoryPacksSectionStyles = makeStyles<ISpcTheme, AccessoryPackClasses>(
  ({ palette }) => ({
    container: {
      width: '100%',
    },
    label: {
      color: palette.text.secondary,
      position: 'relative',
      top: '-12px', // used negative value in order to keep the old customise design
    },
  }),
  { name: 'GqlGustomise_AccessoryPacksSection' },
);

export default accessoryPacksSectionStyles;
